import { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { History, LogOut as OutIcon, LogIn as InIcon } from "lucide-react";

const tm = (s) => new Date(s).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", timeZone: "Asia/Kolkata" });
const TYPE = { home: "Home TD", showroom: "Showroom TD", connected: "Connected Drive", utility: "Utility", transfer: "Transfer", transfer_return: "Loan return" };

export default function SecurityHistory() {
  const { user } = useAuth();
  const isAdmin = user.role === "admin";
  const [branches, setBranches] = useState([]);
  const [branch, setBranch] = useState("");
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [data, setData] = useState({ rows: [] });
  useEffect(() => { if (isAdmin) api.get("/branches").then((r) => setBranches(r.data)).catch(() => {}); }, [isAdmin]);
  useEffect(() => { api.get("/gate/history", { params: { date, ...(branch ? { branch_id: branch } : {}) } }).then((r) => setData(r.data)).catch(() => setData({ rows: [] })); }, [date, branch]);
  return (
    <div className="px-4 py-6 max-w-md mx-auto">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-heading text-2xl font-bold text-[#0E2240] flex items-center gap-2"><History size={22} /> Gate History</h1>
          <p className="text-xs text-slate-500">{isAdmin ? "Read-only log of scans across locations" : "Read-only log of scans at this gate"}</p>
        </div>
        <input data-testid="history-date-input" type="date" value={date} onChange={(e) => setDate(e.target.value)} className="rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm" />
      </div>
      {isAdmin && (
        <select data-testid="history-branch-filter" value={branch} onChange={(e) => setBranch(e.target.value)} className="mt-3 w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm">
          <option value="">All locations</option>
          {branches.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
        </select>
      )}
      <div className="mt-4 space-y-2">
        {data.rows.length === 0 && <div className="rounded-xl border border-dashed border-slate-200 p-6 text-center text-sm text-slate-400">No scans on this date</div>}
        {data.rows.map((r, i) => (
          <div key={i} data-testid={`history-row-${r.reg_no}-${r.direction}`} className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-3">
            <div className={`flex h-10 w-10 items-center justify-center rounded-xl text-white ${r.direction === "out" ? "bg-[#BB162B]" : "bg-emerald-600"}`}>{r.direction === "out" ? <OutIcon size={18} /> : <InIcon size={18} />}</div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center justify-between"><b className="text-[#0E2240]">{r.reg_no}</b><span className="text-xs font-bold text-slate-600">{tm(r.ts)} · {r.direction.toUpperCase()}</span></div>
              <div className="truncate text-[11px] text-slate-500">{r.kecs.join(" · ")} · {TYPE[r.td_type] || r.td_type}{r.customer_name ? ` · ${r.customer_name}` : ""}</div>
              <div className="text-[11px] text-slate-500">Odometer {r.odometer?.toLocaleString("en-IN")} km{r.override && <span className="ml-1 font-bold text-amber-700">· SM override</span>}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
